import { get } from "../../ApiService";
import { SsoApiUrl } from "../../ApiUrl";

export const getFeatureFlags = async () => {
  try {
    const res = await get(`${SsoApiUrl.featureFlag}`);
    return res;
  } catch (error: any) {
    return error.response;
  }
};
